import React, { FC } from 'react';

import styles from './DesignProjectTileBgImage.scss';

type Props = {
    coverPhotoPath: string | null;
};

export const DesignProjectTileBgImage: FC<Props> = ({ coverPhotoPath }) => {
    if (coverPhotoPath && coverPhotoPath.length) {
        coverPhotoPath = `${coverPhotoPath}?width=594`; // iphone + model landscape (736px) * 2
    }
    const imageBgStyle = coverPhotoPath ? { backgroundImage: `url(${coverPhotoPath})` } : undefined;

    return <div className={styles.imageWrapper} style={imageBgStyle} />;
};
